import { injectParams, WETAGS } from 'constants/paths';
import { matchPath } from 'react-router-dom';

export function getBreadcrumbs(pathname: string): { url: string; title: string }[] {
  if (pathname === WETAGS.root) {
    return [];
  }

  const breadcrumbs: { url: string; title: string }[] = [
    { url: WETAGS.root, title: 'Wetags' },
  ];

  const tagMatch = matchPath<{ namespaceId: string; tagId: string }>(pathname, {
    path: WETAGS.tag,
    exact: true,
  });
  if (tagMatch) {
    const { namespaceId, tagId } = tagMatch.params;
    breadcrumbs.push({
      url: injectParams(WETAGS.namespace, { namespaceId }),
      title: namespaceId,
    });
    breadcrumbs.push({
      url: injectParams(WETAGS.tag, { namespaceId, tagId }),
      title: tagId,
    });
    return breadcrumbs;
  }

  const namespaceMatch = matchPath<{ namespaceId: string }>(pathname, {
    path: WETAGS.namespace,
    exact: true,
  });
  if (namespaceMatch) {
    const { namespaceId } = namespaceMatch.params;
    breadcrumbs.push({
      url: injectParams(WETAGS.namespace, { namespaceId }),
      title: namespaceId,
    });
    return breadcrumbs;
  }

  return breadcrumbs;
}
